import { Outlet } from 'react-router-dom';
import { useEffect, useState } from 'react';

import Layout from './Layout';

const WordsLayout = ({ user, onSignOut }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isDesktop = !isMobile;

  const wrapperStyle = {
    height: isDesktop ? '100vh' : 'auto',
    minHeight: isDesktop ? 'auto' : '100vh',
    display: 'flex',
    flexDirection: 'column',
    overflow: isDesktop ? 'hidden' : 'auto',
  };

  const containerStyle = {
    flex: isDesktop ? 1 : 'initial',
    display: 'flex',
    flexDirection: 'column',
    minHeight: isDesktop ? 0 : 'auto',
  };

  const contentStyle = {
    flex: isDesktop ? 1 : 'initial',
    minHeight: isDesktop ? 0 : 'auto',
  };

  return (
    <Layout
      user={user}
      onSignOut={onSignOut}
      containerClassName='px-4'
      containerStyle={containerStyle}
      contentStyle={contentStyle}
      wrapperStyle={wrapperStyle}
      showVersionHighlight={false}
    >
      <Outlet />
    </Layout>
  );
};

export default WordsLayout;
